import { render, staticRenderFns } from "./InternalUserDropdown.vue?vue&type=template&id=8bbdacfe"
import script from "./InternalUserDropdown.vue?vue&type=script&lang=js"
export * from "./InternalUserDropdown.vue?vue&type=script&lang=js"
import style0 from "./InternalUserDropdown.vue?vue&type=style&index=0&id=8bbdacfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports